module.exports = __webpack_public_path__ + "static/8-d8ae2c3101a70b3eaa60151929cada2a.jpeg";